import { createBrowserRouter } from "react-router-dom";

import { FEATURES } from "./features";
import { AppShell } from "./layout/AppShell";
import { LoginPage } from "./login/LoginPage";
import { AuthProvider } from "./providers/AuthProvider";
import { RootErrorBoundary } from "./RootErrorBoundary";

const featureRoutes = FEATURES.flatMap((feature) => feature.routes);

/**
 * The application router. /login is public — no auth gate, no AppShell.
 * All other routes are wrapped in AuthProvider so the session is available
 * throughout the app shell and every feature. The catch-all (*) surfaces
 * the RootErrorBoundary's "Page not found" view for unknown URLs.
 */
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    ),
    errorElement: <RootErrorBoundary />,
    children: [
      ...featureRoutes,
      {
        path: "*",
        element: (
          <div role="alert" style={{ padding: "clamp(16px, 3vw, 32px)" }}>
            <h2 style={{ margin: 0 }}>Page not found</h2>
            <p style={{ color: "var(--text-muted)" }}>
              This page doesn&rsquo;t exist. Use the sidebar to navigate.
            </p>
          </div>
        ),
      },
    ],
  },
]);
